import styled from 'styled-components';

export const Container = styled.div`
  max-width: 580px;
`;

export const Body = styled.div`
  padding: 0px 20px 15px 20px;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 0px 84px 15px 84px;
  }
`;

export const Description = styled.p`
  margin-bottom: 23px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;

  @media ${({ theme }) => theme.queries.minTablet} {
    margin-bottom: 32px;
  }
`;

export const Instructions = styled.p`
  margin-bottom: 15px;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
`;
